import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export const HowToPlay = ({ open, onClose }) => {
  const { t, dict } = useLang();
  const steps = dict.howToSteps;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[90] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
          onClick={onClose}
          data-testid="howto-modal"
        >
          <motion.div
            initial={{ scale: 0.92, y: 20 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.92, y: 20 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-md rounded-3xl border border-white/10 bg-[#15152a] p-6"
          >
            <button
              onClick={onClose}
              data-testid="howto-close"
              className="absolute right-4 top-4 text-white/40 transition-colors hover:text-white"
            >
              <X size={22} />
            </button>
            <h2 className="mb-6 font-display text-2xl font-extrabold uppercase tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-[#f093fb] to-[#f5576c]">
              {t("howToPlay")}
            </h2>
            <div className="space-y-4">
              {steps.map((s, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: -12 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.06 }}
                  className="rounded-2xl border border-white/10 bg-white/5 p-4"
                >
                  <p className="font-display text-sm font-bold text-white">{s.t}</p>
                  <p className="mt-1 text-sm text-white/55">{s.d}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
